// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__RCGA0","ranges":"BmiRanges_ranges__2_KDv"};